import PrepressModalOpener from "../components/PrepressStoreProducts";
import { NotesPanel } from "n2-styles";
import WebpackerReact from "webpacker-react";

export default class ManualOrderEntries {
  constructor(params) {
    this.params = params;
    this.role = params.role || null;
  }

  show() {
    PrepressModalOpener();
    WebpackerReact.setup({ NotesPanel });
  }

  edit() {
    const quantityField = ".js-moe-samples-quantity";
    const sampleAddressFields = [
      ".js-moe-address-samples-name",
      ".js-moe-address-samples-line1",
      ".js-moe-address-samples-city",
      ".js-moe-address-samples-zip",
    ];
    N2.handle("change", quantityField, () => {
      const sampleQuantity = $(quantityField).val();
      if (sampleQuantity === "0") {
        sampleAddressFields.forEach(this.removeFieldRequired);
      }
    });
    N2.handle("submit", "#manual_order_entry_component", (evt) => {
      const sampleQuantity = $(quantityField).val();
      if (sampleQuantity !== "0") {
        sampleAddressFields.forEach((field) => {
          if ($(field).val() === "") this.addFieldError(field);
        });
      }
      if (
        !document
          .getElementById("manual_order_entry_component")
          .reportValidity()
      ) {
        evt.preventDefault();
      }
    });
  }

  addFieldError(fieldId) {
    $(fieldId).prop("required", true);
  }

  removeFieldRequired(fieldId) {
    $(fieldId).prop("required", false);
  }
}
